import {useMemo} from 'react'

export type SearchSort = {
  sortName: string
  sortDirection: 'asc' | 'desc'
  sortInversion: string
}

function useSearchSort(sort: string): SearchSort {
  if (!sort) throw new Error('Please provide default sort to search')

  const sortName = useMemo(() => (sort.startsWith('-') ? sort.substring(1) : sort), [sort])
  const sortDirection = useMemo(() => (sort.startsWith('-') ? 'desc' : 'asc'), [sort])
  const sortInversion = useMemo(() => `${sortDirection === 'asc' ? '-' : ''}${sortName}`, [
    sortName,
    sortDirection,
  ])

  return {sortName, sortDirection, sortInversion}
}

export default useSearchSort
